import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { DurationCommand } from '@src/suite/common/store/story/models/story.models';
import { ProductionCommandsPlaceholderLabels, ProductionFieldName } from '@src/suite/common/utils/ml-2-html-utils';

@Component({
    selector: 'st-duration-command-dialog',
    templateUrl: './duration-command-dialog.html',
    styleUrls: ['./duration-command-dialog.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'st-duration-command-dialog' },
})
export class DurationCommandDialogComponent {
    public ProductionFieldName = ProductionFieldName;
    public ProductionCommandsPlaceholderLabels = ProductionCommandsPlaceholderLabels;
    public command = input<DurationCommand>();
    public commandChange = output<DurationCommand>();
    public onEnterEmitter = output<DurationCommand>();

    public onCommandsObjectChange(event: any, fieldName: ProductionFieldName) {
        if (this.command()) {
            this.command()[fieldName] = event;
            this.commandChange.emit(this.command());
        }
    }

    public onEnterSaveCommand(event: any) {
        this.onCommandsObjectChange(event, ProductionFieldName.DURATION);
        this.onEnterEmitter.emit(this.command());
    }
}
